<template>
    <div class="my-editInfo">
        <div class="bd">
            <span style="display: block;text-align: center;font-size: 18px">
                <span class="el-icon-sell" style="margin-right: 3px"></span>{{deptName}}
            </span>
            <div class="bd-content" style="margin-top: 28px">
                <div class="bd-content-wai">
                    <van-cell-group :border="false">
                        <van-field
                                label-width="50px"
                                v-model="memberName"
                                label="姓名"
                                placeholder="请输入姓名"
                        />
                        <van-field
                                label-width="50px"
                                v-model="phone"
                                label="手机号"
                                placeholder="请输入手机号"
                                type="tel"

                        />
                        <div style="display: flex;flex-direction: row;height: 48px;align-items: center;padding: 0px 20px">
                            <span style="font-size: 15px;color: #646566;width: 59px">性别</span>
                            <van-radio-group v-model="sex" style="font-size: 15px;display: flex;flex-direction: row">
                                <van-radio name="1" style="margin-right: 16px;">男</van-radio>
                                <van-radio name="2">女</van-radio>
                            </van-radio-group>
                        </div>
                    </van-cell-group>
                    <div style="text-align: center;margin-top: 10px;">
                        <van-button type="primary" style="width: 88%;" @click="saveMember">绑 定</van-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDeptId, getDeptName, getYqUrl, removeYqUrl, setCookie} from "../../utils/auth";

    export default {
        data() {
            return {
                memberName: '',
                sex: '1',
                phone: '',
                headPortrait: '',
                openId: '',
                deptId: '',
                deptName: '',

                user: {},
                code: '',
                mid: '',
            };
        },
        async created() {
            document.title = getDeptName()
            this.code = this.$route.params.code
            this.mid = this.$route.params.mid
            this.deptId = getDeptId()
            this.getBdMemberInfo()
        },

        methods: {
            async getBdMemberInfo() {
                let data = {
                    code: this.code,
                    deptId: this.deptId,
                }
                let res = await this.$get("/spm/getSpmBdMemberInfo", data)
                this.deptName = res.deptName
                this.user = res.user
                this.memberName = this.user.nickname
                if (this.user.sex == '1' || this.user.sex == '2') {
                    this.sex = this.user.sex
                } else {
                    this.sex = '1'
                }
                this.headPortrait = this.user.headimgurl
                this.openId = this.user.openId
            },
            async saveMember() {
                if (!this.phone) {
                    this.$notify({
                        message: "手机号不能为空",
                        duration: 1000,
                        background: 'red'
                    });
                    return;
                }
                let data = {
                    memberName: this.memberName,
                    sex: this.sex,
                    phone: this.phone,
                    openId: this.openId,
                    deptId: this.deptId,
                    mid: this.mid,
                }
                let res = await this.$post("/spm/saveYqSpmMember", data)
                if (res.code == 200) {
                    setCookie('spmToken', res.token, 30)
                    var url = getYqUrl()
                    if (url) {
                        this.$router.push(url)
                        removeYqUrl()
                    } else {
                        this.$router.push('/home/' + this.deptId)
                    }
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .my-editInfo {
        margin: 0 auto;
        height: 100%;
        background-color: #EDEDED;
        background-size: 100% 100%;
    }

    .bd {
        width: 65%;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .bd-content {
        width: 100%;
        padding-top: 25px;
        padding-bottom: 25px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        background-color: #fff;
    }

    .bd-content-wai {
        width: 88%;
    }

    .imgs {
        width: 70px;
        height: 70px;
        position: absolute;
        top: -35px;
        left: 38%;
    }

    .res {
        color: rgb(153, 153, 153);
        font-weight: bold;
        font-size: 13px;
        background-color: rgb(255, 255, 255);
        margin: 0 auto;
        line-height: 46px;
        text-align: center;
        box-shadow: 0 3px 3px rgba(21, 62, 78, 0.8);
        margin-top: 20px;
    }

    .regis {
        color: rgb(52, 119, 182);
        cursor: pointer;
    }

    .van-button {
        height: 32px;
    }

    .van-button--primary {
        color: #fff;
        background-color: darkgray;
        border: 1px solid darkgray;
    }

    ::v-deep .van-radio__icon {
        display: inline-block;
        vertical-align: middle;
        line-height: 20px;
        font-size: 15px;
    }
</style>
